import React from "react";

export default function OptionsJoinEmpresa({ embajadores }) {
  return (
    <>
      <div className="flex flex-col sm:flex-row justify-center items-center py-2 sm:space-x-2">
        <h3 className="text-white uppercase font-semibold text-xl">
            Únete a nuestra comunidad:
        </h3>
        <div className="flex items-center -space-x-4 mb-1">
          {embajadores.map((img, i) => (
            <img
              key={i}
              src={img}
              alt="Embajador"
              className="w-10 h-10 rounded-full border-2 border-white object-cover shadow -ml-1 sm:ml-0"
              style={{ zIndex: 10 - i }}
            />
          ))}
          <span className="ml-6 text-gray-200 text-sm font-semibold">
            217 en el Staff
          </span>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row lg:justify-evenly space-y-2 lg:space-y-0">
        <button className="rounded-2xl border border-white text-xs font-semibold text-white py-2 px-8 duration-300 hover:bg-aw-green hover:text-aw-bluedark hover:border-aw-green">
          <span className="block">CLUB DE</span>
          <span className="block">INVITADOS</span>
        </button>
        <button className="rounded-2xl border border-white text-xs font-semibold text-white py-2 px-8 duration-300 hover:bg-aw-green hover:text-aw-bluedark hover:border-aw-green">
          <span className="block">CLUB DE</span>
          <span className="block">EMBAJADORES</span>
        </button>
        <button className="rounded-2xl border border-white text-xs font-semibold text-white py-2 px-8 duration-300 hover:bg-aw-green hover:text-aw-bluedark hover:border-aw-green">
          <span className="block">CLUB DE</span>
          <span className="block">LÍDER DE STAFF</span>
        </button>
      </div>
    </>
  );
}
